import { combineReducers } from 'redux';
import { tripsTabReducer } from './containers/TripsTabContainer/services/reducer';
import { directorSettingsReducer } from './containers/DirectorSettings/service/reducer';
import { smcCarsReducer } from './containers/SMCcars/services/reducer';
import { ResourcesReducer } from './containers/Resources/services/reducer';

export const directorModuleReducer = combineReducers({
  tripsTabReducer,
  directorSettingsReducer,
  smcCarsReducer,
  ResourcesReducer,
});

export type DirectorModuleState = ReturnType<typeof directorModuleReducer>;
